import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    blockUi: {
        position: 'absolute',
        top: '-6px',
        right: '-6px',
    },
    header: {
        position: 'absolute',
        right: theme.spacing(2),
        bottom: theme.spacing(2),
    },
    marginBottom: {
        marginBottom: '8px',
    },
    root: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
    tooltip: {
        display: 'flex',
        flexWrap: 'nowrap',
        background: theme.palette.neutral[100],
        color: theme.palette.text.primary,
        borderRadius: theme.dimensions.borderRadiusInput,
        opacity: 1,
        padding: theme.spacing(0.5, 1),
        fontSize: theme.typography.size.s,

        '& .MuiTooltip-arrow': {
            top: 'unset !important',
            marginTop: `${theme.spacing(0.25)}px !important`,

            '&:before': {
                background: theme.palette.neutral[100],
            },
        },
    },
    headerButton: {
        padding: theme.spacing(1.5),
        marginLeft: '8px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 'fit-content',
        borderRadius: '100%',
        zIndex: 1,
        boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 6px 10px 0px, rgba(0, 0, 0, 0.12) 0px 1px 18px 1px',

        '&:hover': {
            background: theme.palette.primary.main,
        },

        '& svg': {
            height: theme.spacing(4),
            width: theme.spacing(4),
        },
    },
}));

export default useStyles;
